<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="appPage"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="页面名称" prop="page_name">
        <el-input
          v-model="appPage.page_name"
          maxlength="32"
          show-word-limit
          clearable
          placeholder="请输入小程序页面名称"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.appPageList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/app-page';

export default {
  name: RouteConfig.appPageAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    appPage: {
      page_name: '',
    },
    rules: {
      page_name: [{ required: true, message: '请输入页面名称', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.appPage };
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.appPageList.push();
      });
    },
  },
};
</script>
